// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__19cjG","footer":"ModalError_footer__15nmJ"};